export const getLocationById = (state) => (locationId) =>
  state.locations[locationId]

export const location = (state) => state.location

export const milesOptions = (state) => state.milesOptions

export const loading = (state) => state.loading

export const allowPayAtStoreForFulfillment = (
  state,
  getters,
  rootState,
  rootGetters
) => {
  return (fulfillmentCode) => {
    let allowPayAtStore = false
    const currentLocationId = rootGetters['persisted/currentLocationId']
    const location = getters.getLocationById(currentLocationId)
    location?.fulFillments?.every(function (fulfillment) {
      if (fulfillment.codeName == fulfillmentCode) {
        allowPayAtStore = fulfillment.allowPayAtStore
        return false
      }
      return true
    })
    return allowPayAtStore
  }
}

export const payAtStoreAllowForUser = (
  state,
  getters,
  rootState,
  rootGetters
) => {
  return (fulfillmentCode) => {
    let payAtStoreAllowForUser = 4
    const currentLocationId = rootGetters['persisted/currentLocationId']
    const location = getters.getLocationById(currentLocationId)
    location?.fulFillments?.every(function (fulfillment) {
      if (fulfillment.codeName == fulfillmentCode) {
        payAtStoreAllowForUser = fulfillment.payAtStoreUserType
        return false
      }
      return true
    })

    return payAtStoreAllowForUser
  }
}

export const isScanningDLQRCodeRequired = (
  state,
  getters,
  rootState,
  rootGetters
) => {
  let selectedFulfillmentCodeName =
    rootGetters['persisted/selectedFulfillmentCodeName'] || ''
  const fulFillmentLocations = rootState.common?.fulFillmentLocations || {}
  let targetFulfillment =
    fulFillmentLocations[selectedFulfillmentCodeName] || {}
  if (targetFulfillment?.isScanningDLQRCodeRequired)
    return targetFulfillment.isScanningDLQRCodeRequired
  else return false
}
